import { createGrid, themeQuartz } from 'ag-grid-community'
import { makeColumnDefs } from './make-column-defs.js'
import { makeRows } from './make-rows.js'
import { addListeners } from './listeners.js'

export function showTableEntitiesSyncStats (entitiesSyncStatsResponse, browserAppAccount) {
  console.log('showTableEntitiesSyncStats')

  const rows = makeRows(browserAppAccount, entitiesSyncStatsResponse)
  console.log('rows', rows)

  const columnDefs = makeColumnDefs()
  console.log('columnDefs', columnDefs)

  const context = {
    accountingOrganisations: browserAppAccount.data.entities
  }

  const gridOptions = {
    rowData: rows,
    columnDefs,
    defaultColDef: {
      filter: true,
      floatingFilter: true
    },
    autoSizeStrategy: {
      type: 'fitCellContents'
    },
    getRowId: (cellParams) => cellParams.data.id,
    onCellClicked: function (cellParams) {
      console.log('onCellClicked', cellParams)
    },
    context,
    theme: themeQuartz
  }

  const containerId = 'dataGrid'
  const gridContainerElement = document.getElementById(containerId)
  console.log('gridContainerElement', gridContainerElement)
  const gridApi = createGrid(gridContainerElement, gridOptions)
  console.log('grid created', gridApi)

  addListeners(gridApi, gridContainerElement, context)
}
